import styled from "styled-components";
import { newColors } from "constants/newColors";

export const StyledHeader = styled.header`
  padding: 1rem 2rem;
  background: ${newColors.white};
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgb(0 0 0 / 25%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  height: 70px;
  width: 100%;

  img {
    cursor: pointer;
    :hover {
      opacity: 0.8;
    }
  }
`;

export const StyledHorizontalArea = styled.div`
  display: flex;
  align-items: center;

  gap: 1rem;
`;
